import { getAuth, signInWithCustomToken, signOut, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { doc, collection, onSnapshot, getFirestore } from 'firebase/firestore';

class Firebase {
  constructor() {
    this.auth = null;
    this.token = '';
    this.db = null;
    this.isInitial = false;
  }

  // firebaseイニシャル
  initializeApp(firebaseConfig) {
    const app = initializeApp(firebaseConfig);
    this.auth = getAuth(app);
    this.db = getFirestore(app);
    this.isInitial = true;
  }

  // firebaseをログインする
  async login(token) {
    //await setPersistence(this.auth, inMemoryPersistence);
    await setPersistence(this.auth, browserSessionPersistence);
    const userCredential = await signInWithCustomToken(this.auth, token);
    this.token = token;
    return;
  }

  // firebase認証オブジェクト
  onAuthenticate() {
    return this.auth;
  }

  // firebaseトークンをリフレッシュ
  refreshToken() {
    return new Promise((resolve, reject) => {
      if (this.auth.currentUser) {
        this.auth.currentUser
          .getIdTokenResult()
          .then(idTokenResult => {
            this.token = idTokenResult.token;
            resolve(this.token);
          })
          .catch(error => {
            console.debug('firebase refreshToken error: ', error);
          });
      } else {
        this.token = '';
        resolve(this.token);
      }
    });
  }

  /**
   * firestoreのdoc（ドキュメント）配下にデータを変えるとcallbackが呼び出す
   * @param {String} path firestoreのdocパス。例：companyInfomation/112233/userData/user@email.com
   * @param {Function} callback 返るデータハンドリング
   */
  unsubscribe(path, callback) {
    onSnapshot(
      doc(this.db, path),
      doc => {
        const data = doc ? doc.data() : null;
        callback(data);
      },
      error => {
        console.debug('firebase unsubsrice error: ', error);
      }
    );
  }

  /**
   * firestoreのcollection配下にデータを変えるとcallbackが呼び出す
   * @param {String} path firestoreのcollectionパス。例：companyInfomation/112233/userData
   * @param {Function} callback 返るデータハンドリング
   */
  observeCollection(path, callback) {
    onSnapshot(
      collection(this.db, path),
      docs => {
        const result = [];
        docs.forEach(doc => {
          const data = doc.data();
          data.docID = doc.id;
          result.push(data);
        });
        callback(result);
      },
      error => {
        console.debug('firebase observeCollection error: ', error);
      }
    );
  }

  // firebaseログアウト
  async signOut() {
    return await signOut(this.auth);
  }
}

export default Firebase;
